export default "__VITE_ASSET__Bzr0ItSx__"